import { FsPickemPointsPartition } from "db/model/pickemDetails/FsPickemPointsPartition";
import { PointsPartition } from "model/PickemDetails/PointsPartition";
import { nonUndefined } from "Utility";

export const mapPickemPointsPartitions = (
  fsModels: FsPickemPointsPartition[]
) => {
  return nonUndefined(fsModels.map(mapPickemPointsPartition));
};

const mapPickemPointsPartition = (
  fsModel: FsPickemPointsPartition
): PointsPartition | undefined => {
  if (fsModel.points === undefined || !fsModel.position) {
    return undefined;
  }

  return {
    points: fsModel.points,
    position: fsModel.position,
    endPosition: fsModel.endPosition,
  };
};
